// extracted by mini-css-extract-plugin
module.exports = {"marker":"Marker-module--marker--3L98t","icon":"Marker-module--icon--2Z_N7","info":"Marker-module--info--3aE-3","title":"Marker-module--title--3OwKT"};